export const uploadDocumentModalInitValue = {
  data: {
    file: undefined,
    name: '',
    date: '',
    isLoading: false,
  },
  actions: {
    handleChangeFile: () => {},
    handleChangeName: () => {},
    handleChangeDate: () => {},
    handleUploadDocument: () => {},
    handleCloseModal: () => {},
  },
};
